import './App.css';
import Scanner from './Scanner';

function App() {
  return (
    <div className="App">
      <Scanner />
    </div>
  );
}

export default App;
